export const setStateAsync = async function(state) {
  return new Promise(resolve => {
    this.setState(state, resolve);
  });
};

const romans = { 1: 'I', 2: 'II', 3: 'III', 4: 'IV' };

export const convertToRoman = index => romans[index] || romans[1];

export const createSlug = (title, id) =>
  title
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-') + `,${id}`;

export const scrollToElementCenter = (element, delay = 200) =>
  setTimeout(() => {
    element.scrollIntoView({
      block: 'center',
      behavior: 'smooth'
    });
  }, delay);



// WEBPACK FOOTER //
// ./src/common/utils/utils.js